import r from "../../shared-lib/braze-shared-lib.js";
export default class E {
  constructor() {
    this.Ve = {};
  }
  lt(t) {
    if ("function" != typeof t) return null;
    const i = r.Z.Y();
    return (this.Ve[i] = t), i;
  }
  removeSubscription(t) {
    delete this.Ve[t];
  }
  removeAllSubscriptions() {
    this.Ve = {};
  }
  tc() {
    return Object.keys(this.Ve).length;
  }
  Et(t) {
    const i = [];
    for (const r in this.Ve) {
      const s = this.Ve[r];
      i.push(s(t));
    }
    return i;
  }
}
